import React from 'react';
import { observer } from 'mobx-react-lite';

import { Flex, Text } from 'src/kit';
import { Loader } from 'src/components';
import { useJobFeed } from '../hooks/useJobFeed';
import { renderMagazines, IMagazine } from '../helpers/renderMagazines';
import styled from 'styled-components';

export const MagazineList = observer(({ getData }: { getData: (qs) => string }) => {
  const { ref, jobsList, isJobsFetched, error } = useJobFeed(getData, 'magazineList');
  if (isJobsFetched && jobsList.length === 0) {
    return (
      <Flex flexWrap="wrap" pb={70} width="870px" justifyContent="center">
        <Text fontSize={16} fontWeight="light" color="textPrimary">
          No Magazines Found
        </Text>
      </Flex>
    );
  }

  return (
    <>
      <StyledFlex maxWidth={jobsList.length === 0 ? '870px' : 'initial'}>
        {Boolean(jobsList.length) && (
          <>
            {jobsList.map((magazine: IMagazine) => (
              <React.Fragment key={magazine.id}>{renderMagazines(magazine)}</React.Fragment>
            ))}
            {jobsList.length > 1 && <div ref={ref}></div>}
          </>
        )}
      </StyledFlex>
      {!error && !isJobsFetched && <Loader css={{ position: 'relative', height: '200px' }} />}
    </>
  );
});

const StyledFlex = styled(Flex)`
  padding-bottom: 70px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 1024px) {
    flex-wrap: nowrap;
    flex-direction: column;
  }
`;
